<template>
  <data-table :entity="entity"
              :data="tableData"
              :columns="organisationNamesColumns"
              operations="add,delete"
              :disable-permission-checks="true"
              :allowApiDelete="false"
              :go-to-details-on-row-click="false"
              :go-to-add-on-click="false"
              :show-confirm-before-delete="false"
              :clickable="false"
              @on-add="addRow"
              @on-delete="deleteRow"
              ref="table">
    <template v-slot:name="{row}">
      <fg-input placeholder="Name"
                @blur="saveOrUpdateName(row)"
                v-model="row.name">
      </fg-input>
    </template>
  </data-table>
</template>
<script>
  import EditableGridCell from 'src/components/EditableGridCell'
  import entities from 'src/config/entities'
  import OrganizationService from 'src/services/OrganizationService'
  export default {
    name: 'organization-names',
    components: {
      EditableGridCell
    },
    props: {
      names: {
        type: Array,
        default: () => []
      }
    },
    model: {
      prop: 'names',
      event: 'change'
    },
    data () {
      return {
        entity: entities.ORGANIZATION,
        tableData: []
      }
    },
    computed: {
      organizationId() {
        return this.$route.params.id
      },
      organisationNamesColumns () {
        return [
          {
            prop: 'name',
            label: this.$t('organizationNames.labels.name'),
            minWidth: '140px',
            sortable: true
          },
        ]
      }
    },
    methods: {
      async addRow (index = 0) {
        let row = {
          order: null,
          name: '',
          key: this.tableData.length
        }
        this.$refs.table.tableData.splice(index, 0, row)
      },
      async saveOrUpdateName(row) {
        if (row.id) {
          await OrganizationService.updateName(this.organizationId, row)
        } else if(row.creating){
          let index = this.tableData.findIndex(i => i.key === row.key)
          if (index !== -1) {
            setTimeout(() => {
              this.saveOrUpdateInfo(this.tableData[index])
            }, 500)
          }
        } else {
          row.creating = true
          let {data} = await OrganizationService.createName(this.organizationId, row)
          row.creating = false
          let index = this.tableData.findIndex(i => i.key === row.key)
          if (index !== -1) {
            this.tableData.splice(index, 1, data)
          }
        }
      },
      async deleteRow (row) {
        let index = this.tableData.findIndex(d => {
          if (d.id) {
            return d.id === row.id
          }
          return d.key === row.key
        })
        if (!row.id) {
          return
        }
        if (index !== -1) {
          await OrganizationService.deleteName(this.organizationId, row)
        }
      },
    },
    watch: {
      tableData (newVal) {
        this.$emit('change', newVal)
      },
      names: {
        immediate: true,
        handler: function (newVal) {
          if (newVal) {
            this.tableData = newVal
          }
        }
      }
    }
  }
</script>
<style>
</style>
